export default {
  namespaced: true,
  state: {
    isMobile: false, // 是否移动端
    isCollapsed: false, // 是否缩小左菜单
    allSysCode: {}, // 全部字典数据 值是数组形式
    allSysCodeData: {}, // 全部字典数据  值是键值对对象
    isMenu: false, // 是否动态计算过菜单
    menu: [], // 动态计算过的菜单
  },
  getters: {
    getCollapsed: state => state.isCollapsed,
    getAllSysCode: state => state.allSysCode,
    getAllSysCodeData: state => state.allSysCodeData,
  },
  mutations: {
    setIsMobile(state, isMobile) {
      state.isMobile = isMobile;
    },
    setCollapsed(state, isCollapsed) {
      state.isCollapsed = isCollapsed;
    },
    setAllSysCode(state, data) {
      state.allSysCode = data;
    },
    setAllSysCodeData(state, data) {
      state.allSysCodeData = data;
    },
    setIsMenu(state, data) {
      state.isMenu = data;
    },
    setMenu(state, data) {
      state.menu = data;
    },
  },
};
